import React from 'react'
import { CFView, Text } from 'components'
import { css } from 'emotion'
import { logo } from 'images'
import { MEDIA_QUERY } from 'styles'

const LocationSelectModalView = ({ LocationSelectListElement }) => (
  <div className={styles.container}>
    <CFView column w="100%">
      <CFView column w="100%" center mb="2rem">
        <img src={logo} alt="Hoke Poke" height="80" />
      </CFView>
      <CFView mb="2rem">
        <Text heading2 h2 center>
          Pick from the following locations:
        </Text>
      </CFView>
      {LocationSelectListElement}
    </CFView>
  </div>
)

const styles = {
  container: css({
    backgroundColor: 'white',
    border: '3px solid #000',
    color: 'white',
    padding: '4rem',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '45rem',
    [MEDIA_QUERY.SM]: {
      padding: '2rem',
      width: '100%',
    },
  }),
}

export default LocationSelectModalView
